export const breakpoints = {
  small: 375,
  medium: 768,
  large: 1024,
  xlarge: 1280,
  xxlarge: 1440,
}
